import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteDateiArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteDateiArtCommandService],
  exports: []
})
export class DeleteDateiArtCommandServiceModule { }
